// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.bitso",
    name: "Bitso Web3 Wallet",
    homepage: "https://bitso.com/web3-wallet",
    image_id: "7e4953fb-de22-4761-1ff6-8c494549aa00",
    app: {
        browser: "https://bitso.com/web3-wallet",
        ios: "https://apps.apple.com/br/app/bitso-%C3%A9-f%C3%A1cil-comprar-bitcoin/id1292836438",
        android: "https://play.google.com/store/apps/details?id=com.bitso.wallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "bitso://bitso.com/web3-wallet",
        universal: "https://bitso.com/web3-wallet",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map